
import Modal from "@/components/base/modal/Modal"
import { mapGetters } from "vuex"
import { routeToDatenschutz } from "@/helpers/routing"

export default {
    components: {
        Modal,
    },
    data: () => {
        return {
            routeToDatenschutz,
            performanceCookies: false,
            functionalCookies: false,
            marketingCookies: false,
        }
    },
    computed: {
        ...mapGetters("cookie", ["showCookieSettings"]),
    },
    methods: {
        show(bool) {
            this.$store.dispatch("cookie/showCookieSettings", bool)
        },
        saveCookieSelection() {
            this.$store.dispatch("cookie/setCookie", {
                performance: this.performanceCookies ? 1 : 0,
                marketing: this.marketingCookies ? 1 : 0,
                functional: this.functionalCookies ? 1 : 0,
            })
            this.$store.dispatch("cookie/showCookieSettings", false)
        },
        allowAllCookies() {
            this.$store.dispatch("cookie/setCookie", {
                performance: 1,
                marketing: 1,
                functional: 1,
            })
            this.$store.dispatch("cookie/showCookieSettings", false)
        },
    },
}
